import { marginBottom } from "../../../styles";
import MonthSelector from "./MonthSelector/MonthSelector";
import React from "react";
import SelectMonthYearButton from "./SelectMonthYearButton/SelectMonthYearButton";
import styled from "styled-components";
import { useGetMonthStepButtons } from "./useGetMonthStepButtons/useGetMonthStepButtons";
import YearSelector from "./YearSelector/YearSelector";
export type MonthYearControlsProps = {
  monthOffset: number;
  onChange: (newOffset: number) => void;
  open?: boolean;
  selectedDate?: Date;
  toggleOpen: () => void;
};
const ControlRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  width: 100%;
  ${marginBottom.s}
`;
export function MonthYearControls(props: MonthYearControlsProps) {
  const {
    monthOffset,
    open,
    toggleOpen
  } = props;
  const {
    NextMonthButton,
    PreviousMonthButton
  } = useGetMonthStepButtons(props);
  return <div data-sentry-component="MonthYearControls" data-sentry-source-file="MonthYearControls.tsx">
      <ControlRow data-sentry-element="ControlRow" data-sentry-source-file="MonthYearControls.tsx">
        <PreviousMonthButton data-sentry-element="PreviousMonthButton" data-sentry-source-file="MonthYearControls.tsx" />
        {open ? <YearSelector {...props} /> : <SelectMonthYearButton {...{
        monthOffset,
        onClick: toggleOpen
      }} />}
        <NextMonthButton data-sentry-element="NextMonthButton" data-sentry-source-file="MonthYearControls.tsx" />
      </ControlRow>
      {open ? <MonthSelector {...props} /> : null}
    </div>;
}
export default MonthYearControls;